"use client";

import type * as React from "react";
import Box from "@mui/material/Box";
import { useColorScheme } from "@mui/material/styles";

import { NoSsr } from "@/components/core/no-ssr";
import { Stack, Typography } from "@mui/material";


const HEIGHT = 60;
const WIDTH = 60;

type Color = "dark" | "light";

export interface LogoProps {
    color?: Color;
    emblem?: boolean;
    height?: number;
    width?: number;
}

export function Logo({ color = "dark", emblem, height = HEIGHT, width = WIDTH }: LogoProps): React.JSX.Element {

    const url = "/assets/SCADA_Logo_blau_RGB 250x100.png";
    const iconUrl = "/assets/SCADA-Automation_Sinuskurve_blau_RGB_512.png";

    //if (emblem) {
    //	url = color === "light" ? "/assets/logo-emblem.svg" : "/assets/logo-emblem--dark.svg";
    //} else {
    //	//url = color === "light" ? "/assets/logo.svg" : "/assets/logo--dark.svg";
    //   url = color === "light" ? "/assets/SCADA-Automation_Logo_blau_RGB.svg" : "/assets/SCADA-Automation_Logo_blau_RGB.svg";
    //}

    return (
        //direction = "row" justifyContent = "space-between"
        <Stack alignItems="center" sx={{ width: '100%', margin: '0 auto' }}>
            {/*<Box alt="logo" component="img" height={50} src={iconUrl} width={50} />*/}

            {/*<Box sx={{ flex: "1 1 auto" }}>*/}
            {/*    <Typography variant="h5" sx={{*/}
            {/*        color: 'text.secondary',*/}
            {/*    }}>SCADA Automation</Typography>*/}
            {/*</Box>*/}

            <Box alt="logo" component="img" height={66} src={url} width={165} />
        </Stack>
    )
}

export interface DynamicLogoProps {
    colorDark?: Color;
    colorLight?: Color;
    emblem?: boolean;
    height?: number;
    width?: number;
}

export function DynamicLogo({
    colorDark = "light",
    colorLight = "dark",
    height = HEIGHT,
    width = WIDTH,
    ...props
}: DynamicLogoProps): React.JSX.Element {
    const { colorScheme } = useColorScheme();
    const color = colorScheme === "dark" ? colorDark : colorLight;

    return (
        <NoSsr fallback={<Box sx={{ height: `${height}px`, width: `${width}px` }} />}>
            <Logo color={color} height={height} width={width} {...props} />
        </NoSsr>
    );
}
